import React from "react";

// Minimal renderer for the help guides' markdown subset: #/##/### headings, "- " and "1. " lists, **bold**.
const inline = (text, keyBase) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**")
      ? <strong key={`${keyBase}-${i}`} className="font-semibold text-slate-900">{part.slice(2, -2)}</strong>
      : part
  );

export const HelpContent = ({ text }) => {
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };

  (text || "").split("\n").forEach((raw, idx) => {
    const line = raw.trimEnd();
    const bullet = line.match(/^\s*-\s+(.*)/);
    const numbered = line.match(/^\s*\d+\.\s+(.*)/);
    if (bullet || numbered) {
      const type = bullet ? "ul" : "ol";
      if (!list || list.type !== type) { flush(); list = { type, items: [], key: idx }; }
      list.items.push((bullet || numbered)[1]);
      return;
    }
    flush();
    if (!line.trim()) return;
    if (line.startsWith("### ")) blocks.push({ type: "h3", text: line.slice(4), key: idx });
    else if (line.startsWith("## ")) blocks.push({ type: "h2", text: line.slice(3), key: idx });
    else if (line.startsWith("# ")) return; // the dialog title already shows the guide name
    else blocks.push({ type: "p", text: line, key: idx });
  });
  flush();

  return (
    <div className="text-sm leading-relaxed text-slate-700 space-y-2" data-testid="help-content">
      {blocks.map((b) => {
        if (b.type === "h2") return <h2 key={b.key} className="text-base font-bold text-slate-900 pt-3 border-b border-slate-200 pb-1">{b.text}</h2>;
        if (b.type === "h3") return <h3 key={b.key} className="text-sm font-semibold text-emerald-800 pt-1">{b.text}</h3>;
        if (b.type === "p") return <p key={b.key}>{inline(b.text, b.key)}</p>;
        const Tag = b.type;
        return (
          <Tag key={b.key} className={`${b.type === "ul" ? "list-disc" : "list-decimal"} pl-5 space-y-1`}>
            {b.items.map((it, i) => <li key={i}>{inline(it, `${b.key}-${i}`)}</li>)}
          </Tag>
        );
      })}
    </div>
  );
};
